import React from 'react';
import _ from 'lodash';
import { IoMdStar } from 'react-icons/io';
import useSearchHooks from '../../../store/hotel/search-hooks';

const scoreDefault = [
  {
    id: 1,
    level: 1,
    txt: 0,
  },
  {
    id: 2,
    level: 2,
    txt: 0,
  },
  {
    id: 3,
    level: 3,
    txt: 0,
  },
  {
    id: 4,
    level: 4,
    txt: 0,
  },
  {
    id: 5,
    level: 5,
    txt: 0,
  },
].reverse();

export default function StarRatingSelection() {
  const { setStar, search } = useSearchHooks();
  const changeStar = (star) => {
    const currentStar = search.hotelStar ? search.hotelStar.split(',') : [];
    setStar({ hotelStar: _.xor(currentStar, [star.toString()]).join(',') });
  };

  return (
    <div className="table_search_left">
      <ul>
        {scoreDefault.map((item) => {
          return (
            <li
              className={_.includes(search.hotelStar.split(','), item.level.toString()) ? 'act' : ''}
              key={item.id}
              onClick={() => {
                changeStar(item.level);
              }}
            >
              <p>
                {Array.from(Array(item.level), (i, k) => {
                  return <IoMdStar className="star_list" key={`${item.id}-star-${k}`} />;
                })}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
